import React from "react";
import Title from "../title";

export const AppointmentTitle = ({ title, subTitle }) => {
  return (
    <div className="mx-4 border-bottom-1 py-4">
      <Title
        title={title}
        subtitle={subTitle}
        subtitlestyle="ctf-tx-secondary"
      />
    </div>
  );
};
